module.exports = __webpack_public_path__ + "img/f0d6ae13511c64e79f086ef8e7ddd765.45868547.png";